export const NAV = {
  CAMPAIGN_HEADER_NAV: {
    DASHBOARD: 'dashboard',
    CITY_PLANS: 'city-plans',
    MASTER_SCHEDULE: 'master-schedule',
    MANAGE_PAID_AMOUNTS: 'manage-paid-amounts',
    BONUS_RESULTS: 'bonus-results',
    CLIENT_QUESTIONS: 'client-questions',
    LIVE_MAP: 'live-map',
  },
  CITY_HEADER_NAV: {
    AMBASSADORS: 'ambassadors',
    AMBASSADOR: 'ambassador',
    INVENTORY: 'inventory',
    LOCATIONS: 'locations',
    MASTER_SCHEDULE: 'global-planning',
    LIVE_MAP: 'live-map',
    PICKUP: 'pickup',
    STATS: 'stats',
    MANAGE_PAID_AMOUNTS: 'manage-paid-amounts',
    MANAGE_PICKUP_TIMES: 'manage-pickup-times',
    SPY: 'spy',
  },
}



// WEBPACK FOOTER //
// ./src/Config/Routing/nav.js